export default __webpack_public_path__ + "static/media/dashimg.814388ad.png";